import { useEffect } from "react";

const DEFAULT_DESCRIPTION =
  "VELOTEKA — Premium bikes, e-bikes, spare parts and pro service. Imported from Germany, delivered across the Balkans. Based in Strumica, North Macedonia.";

/**
 * Lightweight per-page SEO hook.
 * Sets <title>, meta description, canonical, and Open Graph tags.
 */
export default function useSeo({
  title,
  description = DEFAULT_DESCRIPTION,
  image = "https://customer-assets.emergentagent.com/job_ecommerce-veloteka/artifacts/3afh4xkv_logo%20veloteka.png",
  path,
} = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} · VELOTEKA`
      : "VELOTEKA — Premium Bikes, E-Bikes & Parts";
    document.title = fullTitle;

    const setMeta = (selector, attr, key, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    setMeta('meta[name="description"]', "name", "description", description);
    setMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:image"]', "property", "og:image", image);
    setMeta('meta[property="og:type"]', "property", "og:type", "website");
    setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", fullTitle);
    setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", image);

    const canonicalHref = `https://veloteka.de${path || window.location.pathname}`;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalHref);

    let og = document.head.querySelector('meta[property="og:url"]');
    if (!og) {
      og = document.createElement("meta");
      og.setAttribute("property", "og:url");
      document.head.appendChild(og);
    }
    og.setAttribute("content", canonicalHref);
  }, [title, description, image, path]);
}
